var _title, _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBlackShiledWithArrow = function SvgBlackShiledWithArrow(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "48px",
    viewBox: "0 0 35 48",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "D6F3AAEA-46D8-4168-BEB1-0E973DE79B7E")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.000146112676 0.159299636 34.5132752 0.159299636 34.5132752 47.5018561 0.000146112676 47.5018561"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "2.76667243e-05 1e-05 17.0058 1e-05 17.0058 17.0079 2.76667243e-05 17.0079"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Active-Ended-desktop",
    transform: "translate(-393.000000, -758.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(325.000000, 593.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(68.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6170833,25.8567781 C30.6170833,31.9336753 27.2107098,36.4113386 17.2565402,43.1801337 C7.30285766,36.4118184 3.89648414,31.9341551 3.89648414,25.8567781 L3.89648414,10.4507759 C8.84678161,9.92441533 12.8093574,8.24025351 17.2565402,4.80091678 C21.7042101,8.24025351 25.6672729,9.92441533 30.6170833,10.4502961 L30.6170833,25.8567781 Z M33.5393368,6.78928333 C27.6846019,6.65637369 23.6587106,5.24714769 17.9880777,0.419696964 C17.784494,0.2464826 17.5200301,0.159155691 17.2565402,0.159155691 C16.9920763,0.159155691 16.7285864,0.246002782 16.5250027,0.419217145 C10.8558309,5.24714769 6.82993963,6.65637369 0.974717662,6.78928333 C0.436535972,6.80127878 0.000146112676,7.22975642 0.000146112676,7.75947569 L0.000146112676,25.8567781 C0.000146112676,34.6547242 5.97566752,40.347767 16.4465889,47.2797002 C16.6696543,47.4279641 16.9633408,47.5018561 17.2565402,47.5018561 C17.5502267,47.5018561 17.8434261,47.4279641 18.0664915,47.2797002 C28.5369258,40.347767 34.5134213,34.6547242 34.5134213,25.8567781 L34.5134213,7.75947569 C34.5134213,7.22975642 34.0770315,6.80127878 33.5393368,6.78928333 L33.5393368,6.78928333 Z",
    id: "Fill-1",
    fill: "#222934",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(8.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.67794,3.66211 L6.67794,0.60861 C6.67794,0.27401 6.40744,1e-05 6.06934,1e-05 C5.89854,1e-05 5.73484,0.07481 5.61744,0.19931 L0.15454,6.27431 C-0.04476,6.49851 -0.05186,6.83311 0.13674,7.06441 L5.60314,13.74441 C5.81674,14.00421 6.19754,14.04331 6.45724,13.82981 C6.59964,13.71591 6.67794,13.54151 6.68154,13.36001 L6.68154,10.33501 C11.47884,10.49161 14.47544,12.54151 15.82424,16.59151 C15.90614,16.84061 16.13744,17.00791 16.40084,17.00791 C16.43284,17.00791 16.46484,17.00431 16.49684,17.00081 C16.79224,16.95451 17.00584,16.69831 17.00584,16.40291 C17.00224,9.24601 12.69954,3.99311 6.67794,3.66211",
    id: "Fill-1",
    fill: "#222934",
    mask: "url(#mask-4)"
  }))))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlackShiledWithArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/black_shiled_with_arrow.21d1710c.svg";
export { ForwardRef as ReactComponent };